var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:_vm.featureCodes,attrs:{"id":"app"}},[_c('transition',{attrs:{"name":_vm.transitionCode}},[_c('keep-status',{attrs:{"isDestroy":_vm.isDestroy}},[_c('router-view')],1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }